








































import { Component, Prop, Vue } from 'vue-property-decorator'
import FloorModel from '@/_models/FloorModel'

@Component({
  components: {},
})
export default class SelectFloorBuilding extends Vue {
  // Props
  @Prop()
  selectFloorData!: any

  floors: FloorModel[] = []
  selected: FloorModel = new FloorModel()

  get floorAll(): FloorModel {
    const floorAll = new FloorModel()
    floorAll.name = this.$t('all') as string
    floorAll.building_name = this.selectFloorData.buildingName

    return floorAll
  }

  get filteredFloors(): FloorModel[] {
    if (!this.selectFloorData.floors) {
      return []
    }

    const filteredFloors = this.selectFloorData.floors.filter(
      (item: any): boolean => {
        return (
          String(item.building_name)
            .toLowerCase()
            .indexOf(this.selectFloorData.buildingName.toLowerCase()) !== -1
        )
      }
    )

    // Add "All floor" to list
    filteredFloors.unshift(this.floorAll)

    return filteredFloors
  }

  // methods
  handleSelectFinished(): void {
    this.$emit('handleSelectFloorModalDone', this.selected)
  }

  // After page created
  created() {
    if (this.selectFloorData.selectedFloor._id) {
      this.selected = this.selectFloorData.selectedFloor
    } else {
      this.selected = this.floorAll
    }
  }
}
